
// ▶ Preenchimento automatico por CNPJ (spec 2026-09-17). BrasilAPI: publica,
// gratuita, sem chave. Nunca lanca -- CNPJ invalido, nao encontrado, sem
// sinal ou API fora do ar sao todos o MESMO resultado do lado de quem chama:
// null, formulario continua editavel a mao.
export interface CnpjEncontrado {
  razaoSocial: string
  endereco: string | null
  numero: string | null
  complemento: string | null
  bairro: string | null
  municipio: string | null
  uf: string | null
  cep: string | null
  // Extras (pedido dela, 28/09) -- preenchem so campo vazio, como o resto.
  nomeFantasia: string | null
  ddd: string | null
  telefone: string | null
  email: string | null
  segmento: string | null
}

function textoOuNulo(valor: unknown): string | null {
  return typeof valor === 'string' && valor !== '' ? valor : null
}

export function interpretarRespostaBrasilApi(json: unknown): CnpjEncontrado | null {
  if (typeof json !== 'object' || json === null) return null
  const j = json as Record<string, unknown>
  const razaoSocial = textoOuNulo(j.razao_social)
  if (razaoSocial === null) return null
  // "1133334444": os 2 primeiros digitos sao o DDD. Menos de 10 digitos nao
  // e telefone completo -- melhor nao preencher do que preencher errado.
  const digitos = (textoOuNulo(j.ddd_telefone_1) ?? '').replace(/\D/g, '')
  const fone = digitos.length >= 10 ? digitos : null
  return {
    razaoSocial,
    endereco: textoOuNulo(j.logradouro),
    numero: textoOuNulo(j.numero),
    complemento: textoOuNulo(j.complemento),
    bairro: textoOuNulo(j.bairro),
    municipio: textoOuNulo(j.municipio),
    uf: textoOuNulo(j.uf),
    cep: textoOuNulo(j.cep),
    nomeFantasia: textoOuNulo(j.nome_fantasia),
    ddd: fone ? fone.slice(0, 2) : null,
    telefone: fone ? fone.slice(2) : null,
    email: textoOuNulo(j.email),
    segmento: textoOuNulo(j.cnae_fiscal_descricao),
  }
}

export async function buscarCnpj(cnpj: string): Promise<CnpjEncontrado | null> {
  const limpo = cnpj.replace(/\D/g, '')
  if (limpo.length !== 14) return null
  try {
    const resposta = await fetch(`https://brasilapi.com.br/api/cnpj/v1/${limpo}`, {
      signal: AbortSignal.timeout(8000),
    })
    if (!resposta.ok) return null
    return interpretarRespostaBrasilApi(await resposta.json())
  } catch {
    return null
  }
}
